module.exports = __webpack_public_path__ + "static/media/Logo.1a467769.png";